export default "__VITE_ASSET__kmCDiAtV__"